import {useState} from 'react';
import {createCompany, updateCompany} from '../../../api/company';

const CreateCompanyForm = ({company, onCreated, onCancel}) => {
    const [name, setName] = useState(company?.name ?? '');
    const [website, setWebsite] = useState(company?.website ?? '');
    const [notes, setNotes] = useState(company?.notes ?? '');
    const [startDate, setStartDate] = useState(company?.startDate ?? '');
    const [endDate, setEndDate] = useState(company?.endDate ?? '');
    const [saving, setSaving] = useState(false);

    const submit = (e) => {
        e.preventDefault();
        setSaving(true);
        const body = {
            name,
            website: website || null,
            notes: notes || null,
            startDate: startDate || null,
            endDate: endDate || null,
        };
        const request = company ? updateCompany(company.id, body) : createCompany(body);
        request.then(onCreated).finally(() => setSaving(false));
    };

    return (
        <form className="create-form" onSubmit={submit}>
            <h4 className="create-form__title">{company ? 'Edit Company' : 'New Company'}</h4>
            <div className="create-form__field">
                <label className="create-form__label">Name</label>
                <input className="create-form__input" value={name} onChange={e => setName(e.target.value)} required autoFocus/>
            </div>
            <div className="create-form__field">
                <label className="create-form__label">Website <span className="create-form__optional">(optional)</span></label>
                <input className="create-form__input" value={website} onChange={e => setWebsite(e.target.value)} placeholder="example.com"/>
            </div>
            <div className="create-form__row">
                <div className="create-form__field">
                    <label className="create-form__label">Start date <span className="create-form__optional">(optional)</span></label>
                    <input className="create-form__input" type="date" value={startDate} onChange={e => setStartDate(e.target.value)}/>
                </div>
                <div className="create-form__field">
                    <label className="create-form__label">End date <span className="create-form__optional">(optional)</span></label>
                    <input className="create-form__input" type="date" value={endDate} onChange={e => setEndDate(e.target.value)}/>
                </div>
            </div>
            <div className="create-form__field">
                <label className="create-form__label">Notes <span className="create-form__optional">(optional)</span></label>
                <textarea className="create-form__input create-form__textarea" value={notes} onChange={e => setNotes(e.target.value)} rows={3}/>
            </div>
            <div className="create-form__actions">
                <button type="button" className="create-form__btn" onClick={onCancel}>Cancel</button>
                <button type="submit" className="create-form__btn create-form__btn--primary" disabled={saving || !name.trim()}>
                    {saving ? 'Saving…' : company ? 'Save' : 'Create'}
                </button>
            </div>
        </form>
    );
};

export default CreateCompanyForm;